import base from './base_zh.json';

const extra = {
  'footer_text': `如有任何疑問，請查詢:
  市政署綜合服務中心
  地址: 澳門南灣大馬路762-804號中華廣場二樓
  政府綜合服務大樓
  地址: 澳門黑沙環新街52號
  離島政府綜合服務中心
  地址: 氹仔哥英布拉街225號3樓
  查詢：(853) 2822 5000 圖文傳真：(853) 2822 3000`,

  
}


const output = Object.assign({}, base, extra);
export default output;